import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, I } from '@leanin/ui';
import { FlowShell } from '@/components/onboarding/FlowShell';
import { ChecklistColumn } from '@/components/onboarding/ChecklistColumn';
import { useOnboardingProgress } from '@/components/onboarding/progress';
import { useFinishOnboarding } from '@/components/onboarding/finish-onboarding';
import { NL_ROLE, NL_STEPS } from './-steps';
import {
  STEP_CONTENT_BY_KEY,
  patchChecklistHref,
} from '@/components/onboarding/checklist-registry';
import { PERSONA_STEP_KEYS } from '@/components/onboarding/persona-steps';

export const Route = createFileRoute('/onboarding/nl/complete')({
  component: NLOnboardingCompletePage,
});

function NLOnboardingCompletePage() {
  const navigate = useNavigate();
  const finish = useFinishOnboarding('nl');
  const { data: progress } = useOnboardingProgress();

  const networkChecklist = PERSONA_STEP_KEYS['network-leader'].map((key) => {
    const content = STEP_CONTENT_BY_KEY[key];
    const href = progress
      ? patchChecklistHref(key, content.href, progress)
      : content.href;
    return { title: content.title, sub: content.sub, cta: content.cta, href };
  });

  return (
    <FlowShell
      role={NL_ROLE}
      stepIndex={5}
      steps={NL_STEPS}
      title="Explore your community."
      primary={
        <Button variant="primary" icon={I.arrow} onClick={() => void finish()}>
          Finish onboarding
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/nl/welcome' })}
        >
          Return to welcome message
        </Button>
      }
    >
      <ChecklistColumn
        eyebrow="Next steps"
        title="Your Network Leader Checklist"
        items={networkChecklist}
        onNavigate={(href) => void finish(href)}
      />
    </FlowShell>
  );
}
